import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M1.75 6.75V17.25C1.75 18.9069 3.09315 20.25 4.75 20.25H19.25C20.9069 20.25 22.25 18.9069 22.25 17.25V6.75C22.25 5.09315 20.9069 3.75 19.25 3.75H4.75C3.09315 3.75 1.75 5.09315 1.75 6.75ZM5.25 9.5C5.25 7.70507 6.70507 6.25 8.5 6.25C10.2949 6.25 11.75 7.70507 11.75 9.5C11.75 10.3683 11.4095 11.1571 10.8547 11.74C11.9868 12.3855 12.75 13.6036 12.75 15V15.5C12.75 15.9142 12.4142 16.25 12 16.25H5C4.58579 16.25 4.25 15.9142 4.25 15.5V15C4.25 13.6036 5.01322 12.3855 6.14527 11.74C5.59051 11.1571 5.25 10.3683 5.25 9.5ZM8.5 12.75H8C6.84186 12.75 5.88809 13.625 5.76373 14.75H11.2363C11.1119 13.625 10.1581 12.75 9 12.75H8.5ZM8.5 11.25C9.4665 11.25 10.25 10.4665 10.25 9.5C10.25 8.5335 9.4665 7.75 8.5 7.75C7.5335 7.75 6.75 8.5335 6.75 9.5C6.75 10.4665 7.5335 11.25 8.5 11.25ZM13.75 8C13.75 7.58579 14.0858 7.25 14.5 7.25H18.5C18.9142 7.25 19.25 7.58579 19.25 8C19.25 8.41421 18.9142 8.75 18.5 8.75H14.5C14.0858 8.75 13.75 8.41421 13.75 8ZM13.75 11C13.75 10.5858 14.0858 10.25 14.5 10.25H18.5C18.9142 10.25 19.25 10.5858 19.25 11C19.25 11.4142 18.9142 11.75 18.5 11.75H14.5C14.0858 11.75 13.75 11.4142 13.75 11Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
